import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const Snowfall = () => {
  const snowflakes = useMemo(() => {
    return Array.from({ length: 50 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      animationDuration: `${Math.random() * 10 + 10}s`,
      animationDelay: `${Math.random() * 5}s`,
      opacity: Math.random() * 0.6 + 0.2,
      size: Math.random() * 3 + 2,
    }));
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {snowflakes.map((flake) => (
        <motion.div
          key={flake.id}
          className="absolute rounded-full bg-white"
          style={{
            left: flake.left,
            width: `${flake.size}px`,
            height: `${flake.size}px`,
            opacity: flake.opacity,
          }}
          animate={{
            y: ['0vh', '100vh'],
            x: [0, Math.sin(flake.id) * 50, 0],
          }}
          transition={{
            duration: parseFloat(flake.animationDuration),
            delay: parseFloat(flake.animationDelay),
            repeat: Infinity,
            ease: "linear",
          }}
          initial={{ y: '-10vh' }}
        />
      ))}
    </div>
  );
};

export default Snowfall;
